<script lang="ts" setup>
import { LanguageSelectorComp, ThemeSelector, DateComp, CollapseContent, ButtonComp, RouterLink, DisplayTime } from '@/components';
import { useEventCommonStoreRef, useEventCommonStore, useEventStoreRef } from '@/stores';
import { onMounted, ref } from 'vue';
import HeaderEventTypeAhead from './HeaderEventTypeAhead.vue';
import HeaderEventManager from './HeaderEventManager.vue';
import HeaderEventRaceControl from './HeaderEventRaceControl.vue';
import { isLocalHost, isNextDev } from '@/utilities/utils';

const comStore = useEventCommonStore();
const { Event } = useEventCommonStoreRef();
const { eventID } = useEventStoreRef();

// is the component hidden
const isHidden = ref(false);

onMounted(() => {
    comStore.EnsureLoaded(['Event']);
});
</script>
<!--
The whole header can collapse, if so we show a open again icon in top right corner
-->
<template>
    <div v-if="isHidden">
        <div class="position-fixed top-0 end-0 me-5 overlay-2 border shadow">
            <ButtonComp
                button-type="Secondary"
                icon="fa-down-from-line"
                @click="isHidden = !isHidden"
            />
        </div>
    </div>

    <CollapseContent
        :remove-content="false"
        :visible="!isHidden"
    >
        <header class="p-3 d-none d-md-flex flex-row border-bottom">
            <div class="container-fluid d-grid gap-3 align-items-center">
                <div class="d-flex gap-5 flex-nowrap align-items-center justify-content-lg-between">
                    <RouterLink
                        path="/home"
                        class="d-flex align-items-center mb-2 mb-lg-0 text-dark text-decoration-none"
                    >
                        <img
                            v-if="isLocalHost()"
                            height="40"
                            src="@/assets/img/EQWhite-local.png"
                            class="nav-logo"
                        />
                        <img
                            v-else-if="isNextDev()"
                            height="40"
                            src="@/assets/img/EQWhite-dev.png"
                            class="nav-logo"
                        />
                        <img
                            v-else
                            height="40"
                            src="@/assets/img/EQWhite.png"
                            class="nav-logo"
                        />
                    </RouterLink>
                    <span class="text-center">
                        <template v-if="Event != null">
                            <span class="display-2">{{ Event.Name }}</span>

                            <DateComp
                                class="text-muted ms-2"
                                :value="Event.Date"
                                format="DATE"
                                :monospace="false"
                            />
                        </template>
                    </span>

                    <div class="flex-shrink-1 px-3 py-1">
                        <div class="d-flex align-items-center p-2 gap-2 position-absolute end-0 top-0 mt-2">
                            <DisplayTime class="d-none d-sm-block" />
                            <HeaderEventTypeAhead />
                            <HeaderEventRaceControl v-if="(eventID ?? 0) > 0" />
                            <HeaderEventManager />
                            <LanguageSelectorComp />
                            <ThemeSelector />
                            <ButtonComp
                                button-type="Secondary"
                                @click="isHidden = !isHidden"
                                icon="fa-up-to-line"
                            />
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
        </header>
    </CollapseContent>
</template>
